module.exports = __webpack_public_path__ + "img/intro.c718a7b1.png";